// extracted by mini-css-extract-plugin
export var isWon = "LegStatus-module--isWon--9e5e3";
export var legCount = "LegStatus-module--legCount--b737a";
export var legStatus = "LegStatus-module--legStatus--86f52";
export var legStatusContainer = "LegStatus-module--legStatusContainer--949bc";
export var legStatusOverflow = "LegStatus-module--legStatusOverflow--9eb0b";
export var lostIcon = "LegStatus-module--lostIcon--b99f3";
export var pendingIcon = "LegStatus-module--pendingIcon--8fdf7";
export var settledIcon = "LegStatus-module--settledIcon--9da16";
export var tooltipArrow = "LegStatus-module--tooltipArrow--ae6cc";
export var tooltipContent = "LegStatus-module--tooltipContent--d1666";
export var tooltipIcon = "LegStatus-module--tooltipIcon--4fa0c";
export var tooltipOverrides = "LegStatus-module--tooltipOverrides--7a22c";
export var tooltipStat = "LegStatus-module--tooltipStat--7a58a";
export var tooltipText = "LegStatus-module--tooltipText--4b51f";
export var voidIcon = "LegStatus-module--voidIcon--9e7fe";
export var wonIcon = "LegStatus-module--wonIcon--e1af7";